export default {
  HEADING: 'Interessiert an der Übernahme von KV-Diensten?',
  HEADING_SUB: 'Verfügbare KV-Dienste',
  BUTTON_SHOW_ALL: 'Alle Dienste anzeigen',
};
